import controller from './chart-analog.controller';
import { template, bindings } from '../chart-abstract-base';

export default {
    bindings,
    controller,
    template
};
